import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { SelectStudentPackage } from "../Action/CourseAction";
import { PurchasedPackages } from "../Action/PacakgeAction";
import { get_contact_batch } from "../Action/ContactBatchAction";

export default function MobileHeaderSection({ Page, OpenSideMenu }) {
  const dispatch = useDispatch();
  const [IsPaidPackages, setIsPaidPackages] = useState([]);
  const [SelectPack, setSelectPack] = useState("");

  const { OrdersRec } = useSelector((s) => s.ListOrdersReducer);
  const { PackageData } = useSelector((s) => s.SelectStudentPackageReducer);

  useEffect(() => {
    let PackagesBuy = [];
    let Package_Id = "";
    let Pack = {};
    if (OrdersRec) {
      for (let i = 0; i < OrdersRec?.length; i++) {
        if (OrdersRec[i]?.isPaid) {
          PackagesBuy.push({ ...OrdersRec[i] });
          Package_Id = OrdersRec[i]?.PackageId?._id;
          Pack = OrdersRec[i]?.PackageId;
        }
      }
    }

    setIsPaidPackages([...PackagesBuy]);
    if (!PackageData?._id) {
      dispatch(SelectStudentPackage(Pack));
      setSelectPack(Package_Id);
    }
  }, [OrdersRec]);

  useEffect(() => {
    dispatch(PurchasedPackages());
    dispatch(get_contact_batch());
  }, [dispatch]);

  return (
    <div style={{ width: "100%" }}>
      <header className="header">
        <div className="header-left">
          <button className="menu-btn" id="menuBtn" onClick={OpenSideMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <h1 id="pageTitle">{Page}</h1>
        </div>
        <div className="header-right">
          <div className="pck_slt" id="courseSelector">
            <select
              name="SelectPack"
              value={PackageData?._id || SelectPack}
              onChange={(e) => {
                let Pack = IsPaidPackages?.find((ev) => {
                  if (ev.PackageId?._id == e.target.value) return ev;
                });
                  localStorage.setItem("std-pack",JSON.stringify(Pack?.PackageId))
                dispatch(SelectStudentPackage(Pack?.PackageId));
                setSelectPack(e.target.value);
              }}
              className="course-dropdown"
            >
              <option>Select Package</option>
              {IsPaidPackages?.map((eh, ib) => (
                <option key={ib + 567} value={eh?.PackageId?._id}>
                  {eh?.PackageId?.Name}
                </option>
              ))}
            </select>
          </div>
          {/* <!-- <button className="icon-btn search-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
          </svg>
      </button> --> */}
          {/* <Link to="/notification"> */}
          <button className="icon-btn notification-btn">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
              <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
          </button>
          {/* <button className="notify-number">
              <span>3</span>
            </button> */}
          {/* </Link> */}
        </div>
      </header>
    </div>
  );
}
